import * as dayjs from 'dayjs'
import 'dayjs/locale/da'

export default {
  install: (app, options) => {
    app.config.globalProperties.$dayjs = dayjs
  },
}
